import React from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/ui/Button";

const CommentsForm = ({ onSubmit, onBack, defaultValues }) => {
  const { register, handleSubmit } = useForm({ defaultValues });

  const inputStyle =
    "w-full px-4 py-3 rounded-xl border text-[16px] md:text-[20px] 2xl:text-[24px] border-[#183076] focus:outline-none focus:ring-2 focus:ring-[#183076] bg-white transition-all";
  const labelStyle =
    "font-bold text-[#183076] text-[16px] md:text-[20px] 2xl:text-[24px]";

  return (
    <section className="w-full max-w-[1800px] mx-auto px-4">
      <div className="bg-white border rounded-[2rem] p-8 md:p-12 shadow-sm border-[#183076]">
        <h2 className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#183076]">
          Additional Comments
        </h2>
        <p className="text-[16px] md:text-[20px] 2xl:text-[24px] text-[#183076] mt-2 mb-[30px]">
          Any other details or special requirements
        </p>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="flex flex-col gap-2">
            <label className={labelStyle}>Comments/Instructions</label>
            <textarea
              {...register("comments")}
              rows={6}
              className={inputStyle}
              placeholder="Enter your comments here..."
            />
          </div>

          <div className="flex justify-center gap-4 pt-6">
            <Button
              type="button"
              onClick={onBack}
              className="px-10 py-3 border border-[#183076] text-[#183076] rounded-full font-bold"
            >
              Back
            </Button>
            <Button
              type="submit"
              className="px-16 py-3 bg-[#183076] text-white rounded-full font-bold border border-[#183076] transition-colors shadow-lg"
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};
export default CommentsForm;
